module.exports = __webpack_public_path__ + "files/ba1684dcebfae2c588f55d3f60da2add.png";